module.exports = __webpack_public_path__ + "img/ergo_logo.91721603.svg";